export const MARKETPLACE_IFRAME_ID = 'marketplace';
export const EVENT_PREFIX = 'livechat:';

export const enum MarketplaceAppsRoutes {
  Apps = '/apps/marketplace/apps',
  PrivateApps = '/apps/marketplace/private-apps',
  InReviewApps = '/apps/marketplace/in-review-apps',
}
